import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';

import { adminAuthenticationReducers, adminAuthenticationWatchers } from './authentication';
import { adminCustomersReducers, adminCustomersWatchers } from './customers';
import { adminFeatureFlagsReducers, adminFeatureFlagsWatchers } from './feature-flags';
import { adminOidcConfigurationsReducers, adminOidcConfigurationsWatchers } from './oidc-configurations';
import { adminSearchReducers, adminSearchWatchers } from './search';
import { adminUsersReducers, adminUsersWatchers } from './users';

export const adminReducers = combineReducers({
	authentication: adminAuthenticationReducers,
	customers: adminCustomersReducers,
	featureFlag: adminFeatureFlagsReducers,
	oidcConfigurations: adminOidcConfigurationsReducers,
	search: adminSearchReducers,
	users: adminUsersReducers
});

export const adminWatchers = combineAllWatchers([
	adminAuthenticationWatchers,
	adminCustomersWatchers,
	adminFeatureFlagsWatchers,
	adminOidcConfigurationsWatchers,
	adminSearchWatchers,
	adminUsersWatchers
]);
